import { ImportApi } from '@/api/import';
import { DataImportFileFilters } from '@/api/requests/import/data-import-file-filters';
import { Forbidden } from '@/api/responses/forbidden';
import { snackbarProgrammatic } from '@/components/snackbar';
import router from '@/router';
import store from '@/store';
import { State } from '@/stores/import/state';
import { ActionContext, ActionTree } from 'vuex';

const importApi = new ImportApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public loadDataImportFilesAsync = async (context: ActionContext<State, any>) => {
        try {
            const filters: DataImportFileFilters = store.getters['import/dataImportFileFilters'];
            const response = await importApi.getDataImportsAsync({ ...filters });
            context.commit('setDataImportFiles', response);
        } catch (e) {
            if (e instanceof Forbidden) {
                router.push({ name: 'forbidden' });
            } else if (e instanceof Error) {
                snackbarProgrammatic.open({ message: e.message, type: 'is-danger' });
            } else {
                snackbarProgrammatic.open({ message: `Could not load data import files.`, type: 'is-danger' });
            }
        }
    }

    public resetDataImportFiles = async (context: ActionContext<State, any>) => {
        context.commit('setDataImportFiles', { files: [], total: 0 });
    }

    public setDataImportFileFilters = async (context: ActionContext<State, any>, filters: DataImportFileFilters) => {
        context.commit('setDataImportFileFilters', filters);
    }
}
